(function initMobileCarouselVideoLazy() {
  const root = document.querySelector('#viewport_scroll');
  if (!root) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      const slide = en.target;
      const vid = slide.querySelector('video.mobile_gallery_video');
      if (!vid) return;

      if (en.isIntersecting) {
        if (!vid.querySelector('source')) {
          const src = vid.getAttribute('data-src');
          if (src) {
            const s = document.createElement('source');
            s.type = 'video/mp4';
            s.src = src;
            vid.appendChild(s);
            vid.preload = 'metadata';
            vid.load();
          }
        }
        vid.muted = true;
        vid.play().catch(() => {});
      } else {
        try { vid.pause(); } catch (e) {}
        const s = vid.querySelector('source');
        if (s) {
          s.remove();
          vid.load();
        }
      }
    });
  }, {
    root,
    threshold: 0.6
  });

  root.querySelectorAll('.carousel__slide').forEach(slide => io.observe(slide));

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      root.querySelectorAll('video.mobile_gallery_video').forEach(v => { try { v.pause(); } catch(e){} });
    }
  });
})();